import { useQuery } from "@tanstack/react-query";
import {
  CustomerExperienceUsersClient,
  CxUsersByTenantRequestDto,
  IPaginatedResultDto_1OfCxUserAccountDto,
} from "@lib/ShiOneClient";
import { useApi } from "@utils/useApi";
import ms from "ms";

const QUERY_KEY = "client-users";

const noItems : IPaginatedResultDto_1OfCxUserAccountDto = {
  items: [],
  totalCount: 0,
  pageNumber: 0,
  pageSize: 0,
  totalPages: 0,
};

export default function useGetCxUserAccounts(
  request: CxUsersByTenantRequestDto | null,
) {
  const api = useApi(CustomerExperienceUsersClient);

  return useQuery({
    queryKey: [
      QUERY_KEY,
      request?.tenantId ?? null,
      request?.userTypeFilter ?? null,
      request?.searchString ?? null,
    ],
    enabled: Boolean(request?.tenantId),
    queryFn: async (): Promise<IPaginatedResultDto_1OfCxUserAccountDto> => {
      if (!request?.tenantId) return noItems;
      return await api.getClientUsersByTenantId(request);
    },
    staleTime: ms("30m"),
  });
}
